import { render } from "./FooterAdmin.vue?vue&type=template&id=4d1337ec"
import script from "./FooterAdmin.vue?vue&type=script&lang=js"
export * from "./FooterAdmin.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yaakovbeckerman/projects/vue-notus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__